export const ROUTES = {
  HOME: "/",
  PRIVACY_POLICY: "/privacy",
  TERMS: "/tnc",
  BLOG: "/blog",
  DISCLAIMER: "/disclaimer",
  COOKIES_POLICY: "/cookies-policy",
  DELETE_ACCOUNT: "/delete",
  CHANGE_LANGUAGE: "/change-language",
  ABOUT: "/about",
  CONTACT: "/contact",
  SUBSCRIBE: "/subscribe",
  FAQ: "/getwebfaq",
  SIX_DEGREE_SEPERATION_WIKI_URL:
    "https://en.wikipedia.org/wiki/Six_degrees_of_separation",
};
